import React, { FC } from "react";
import { useSelector } from "react-redux";
import { StepperComponent } from "shared/components/stepper/stepper";
import { Stepper } from "states/global-value/global-value.models";
import { RootState } from "../../app.store";
interface HeaderProps {};
export const Header: FC<HeaderProps> = (props) => {
  const cart = useSelector((state: RootState) => state.cart);
  const step = useSelector(
    (state: RootState) => state.globalValue.activeStepper
  );
  const title = () => {
    switch (step) {
      case Stepper.Cart:
        return "Giỏ hàng";
      case Stepper.Address:
        return "Địa chỉ";
      case Stepper.Checkout:
        return "Đặt hàng";
    }
  };
  const renderLayout = () => {
    return (
      <div className="section-header container">
        <StepperComponent step={step} />
        {step !== Stepper.Checkout && (
          <div className="head-cart p-bot-2">
          <div className="head-container">
            <h1 className="h0 text-black text-bold text-uppercase">
              {title()}
              {step === Stepper.Cart && (
                <span className="count-container">
                  ({cart?.shoppingCartItems?.length} sản phẩm)
                </span>
              )}
            </h1>
          </div>
          </div>
        )}
      </div>
    );
  };
  return renderLayout();
};
